module.exports = __webpack_public_path__ + "static/img/updated_successfully.82dced19.svg";